import React from 'react';
import { TextField, type TextFieldProps } from '@mui/material';
import { intakeCompactInputSx, intakeFieldSlot } from './intakeFormLayout';

/** ラベルは IntakeFormRow 側で表示する TextField */
const IntakeTextField: React.FC<TextFieldProps> = ({ sx, ...props }) => (
  <TextField
    {...intakeFieldSlot}
    {...props}
    sx={[intakeCompactInputSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
  />
);


export default IntakeTextField;
